import { render, staticRenderFns } from "./NullLayout.vue?vue&type=template&id=05921833&scoped=true&"
import script from "./NullLayout.vue?vue&type=script&lang=js&"
export * from "./NullLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05921833",
  null
  
)

export default component.exports